import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { AuthenticateService } from '../../shared/services/authenticate.service'
import { Router, ActivatedRoute } from '@angular/router';
import { ngxLoadingAnimationTypes, NgxLoadingComponent } from 'ngx-loading';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.sass']
})
export class ForgotPasswordComponent implements OnInit {

  @ViewChild('ngxLoading') ngxLoadingComponent: NgxLoadingComponent;
  @ViewChild('customLoadingTemplate') customLoadingTemplate: TemplateRef<any>;
  public ngxLoadingAnimationTypes = ngxLoadingAnimationTypes;

  model: any = {};
  type: string;
  public loading: boolean;
  globalImgUrl: string;
  show: boolean = false;
  forgotpwdForm: FormGroup;
  alert: any[] = [];
  display: string = "none";

  constructor(private formBuilder: FormBuilder, private authService: AuthenticateService, private route: ActivatedRoute,
    private router: Router) { }

  ngOnInit() {
    this.type = 'forgot';
    this.forgotpwdForm = this.formBuilder.group({
      email: ['', Validators.required],
      confirmcode: ['', Validators.required],
      newpassword: ['', Validators.required],
    });
  }

  ngDoCheck() {
    if (!this.globalImgUrl) {
      this.globalImgUrl = this.authService.s3url();
    }
  }

  showhidepwd() {
    this.show = !this.show
  }

  forgotPassword() {
    if (!this.model.confirmcode) {
      this.model.confirmcode = "noOtp";
    }
    console.log("model data : ", this.model)

    this.authService.forgotPassword(this.model).then((data: any) => {
      console.log("forgetdata : ", data)
      if (JSON.stringify(data) == '{}' || JSON.parse(data.body).CodeDeliveryDetails) {
        this.model.confirmcode = '';
        this.type = 'update';
      } else if (JSON.parse(data.body).code == 'LimitExceededException') {
        this.type = 'LimitExceeded';
      } else if (JSON.parse(data.body).code == 'UserNotFoundException') {
        this.type = 'UserNotFound'
      } else if (JSON.parse(data.body).code == 'ExpiredCodeException') {
        this.type = 'ExpiredCodeException'
      } else if (JSON.parse(data.body).code == 'CodeMismatchException') {
        this.type = 'CodeMismatch'
      } else if (JSON.parse(data.body).code == 'PasswordResetRequiredException') {
        this.type = 'PasswordReset'
      } else if (JSON.parse(data.body).code == 'success') {
        this.type = 'success';
        this.router.navigate(['']);
      } else {
        this.type = 'error'
      }
      this.model.confirmcode = '';
      console.log("type", this.type)
      this.forgotpwdForm.reset();
    })
  }

  updatePassword() {
    console.log("model data : ", this.model);
    this.authService.updatePassword(this.model).then((data: any) => {
      console.log("forgetdata : ", data);
      let responce = JSON.parse(data.body);
      if (responce && (responce.result == 'SUCCESS' || responce.result == 'Success')) {
        Swal({ text: 'Password updated successfully' });
        this.router.navigate(['/login']);
      } else {
        Swal({ text: responce.message });
      }
      // this.forgotpwdForm.reset();
    })
  }

  focusFn() {
    this.display = "block";
  }

  checknewpassword(pwd) {
    console.log("pwd", pwd)
    if (pwd != '') {
      var lowerCaseLetters = /[a-z]/g;
      var upperCaseLetters = /[A-Z]/g;
      var numbers = /[0-9]/g;
      var specialchar = /[!@#\$%\^&\*]/g
      for (let i = 0; i < 5; i++) {
        if (i == 0) {
          this.alert[i] = pwd.match(lowerCaseLetters) ? true : false;
          console.log("alert", this.alert[i])
        } else if (i == 1) {
          this.alert[i] = pwd.match(upperCaseLetters) ? true : false;
        } else if (i == 2) {
          this.alert[i] = pwd.match(numbers) ? true : false;
        } else if (i == 3) {
          this.alert[i] = pwd.match(specialchar) ? true : false;
        } else if (i == 4) {
          this.alert[i] = pwd.length >= 8 ? true : false;
        }
      }
    } else {
      for (let i = 0; i < 5; i++) {
        this.alert[i] = false;
      }
    }
  }

}
